
/**
 * 设置组件最小高度为 350px，默认高度为507px
 */
export const judgeHeight = (screenHeight: string | null) => {
    if (!screenHeight) return '507px';
    let h = Number(screenHeight.substring(0, screenHeight.length - 2))
    console.log(h, 'height!!!!!!');
    if (/(.+(?=px$))/.test(screenHeight)) {
        if (h < 358) {
            return '358px';
        } else {
            return screenHeight;
        }
    } else if (/(.+(?=vh$))/.test(screenHeight)) {
        return screenHeight;
    } else {
        return '507px';
    }
};
export const judgeMapHeight = (screenHeight: string | null) => {
    if (!screenHeight) return '507px';
    let h = Number(screenHeight.substring(0, screenHeight.length - 2))
    if (/(.+(?=px$))/.test(screenHeight)) {
        if (h < 358) {
            return '358px';
        } else {
            return `calc(${screenHeight}px - 17vh)`;
        }
    } else if (/(.+(?=vh$))/.test(screenHeight)) {
        if (h > 17) {
            return `${h - 17}vh`;
        } else {
            return '0vh'
        }
    } else {
        return '507px';
    }
};

/**
 * 设置列表最小高度为 350px，默认高度为507px
 */
export const judgeListPaddingTop = (mapHeight: string | null, searchBarShow: boolean) => {
    if (!mapHeight) return '507px';
    if (/(.+(?=vh$))/.test(mapHeight)) {
        // 有搜索框
        if (searchBarShow) {
            return '34.5vh'
        } else {
            return '27vh'
        }
    } else {
        if (searchBarShow) {
            return '230px'
        } else {
            return '200px'
        }
    }
};
/**
* 设置列表最小高度为 350px，默认高度为507px
*/
export const judgeListWrapHeight = (mapHeight: string | null, searchBarShow: boolean) => {
    if (!mapHeight) return '507px';
    if (/(.+(?=vh$))/.test(mapHeight)) {
        // 有搜索框
        if (searchBarShow) {
            return '65.5vh'
        } else {
            return '73vh'
        }
    } else {
        if (searchBarShow) {
            return '230px'
        } else {
            return '200px'
        }
    }
};

/**
 * 设置列表最小高度为 350px，默认高度为507px
 */
export const judgeListHeight = (screenHeight: string | null, searchBarShow: boolean) => {
    if (!screenHeight) return '507px';
    let h = Number(screenHeight.substring(0, screenHeight.length - 2))
    if (/(.+(?=px$))/.test(screenHeight)) {
        if (h < 358) {
            return `${(358 - 251)}px`;
        } else {
            return `${(h - 251)}px`;
        }
    } else if (/(.+(?=vh$))/.test(screenHeight)) {
        if (h < 54) {
            return `${(385 - 251)}px`;
        } else {
            // 有搜索框
            if (searchBarShow) {
                return `${h - 44.5}vh`;
            } else {
                return `${h - 36}vh`;
            }
        }
    } else {
        return '507px';
    }
};

declare const AMap: any;
export const location2CityCode = ({ map, lng, lat }) => {
    return new Promise<{ cityCode: string, cityName: string }>((resolve, reject) => {
        map.plugin('AMap.Geocoder', () => {
            const geolocation1 = new AMap.Geocoder({
                city: '' //默认：“全国”
            });
            geolocation1.getAddress([lng, lat], (status, result) => {
                if (status === 'complete' && result.regeocode) {
                    console.log('根据经纬度获取地址信息', result);
                    let address = result.regeocode && result.regeocode.addressComponent;
                    resolve({ cityCode: address.citycode, cityName: address.city||address.province })
                } else {
                    reject('获取地址信息失败')
                }
            });
        });
    })
}
